import qs from 'query-string';

export const getQuery = () => {
  const { query } = qs.parseUrl(window.location.search);
  return query;
};
